import dayjs from 'dayjs';

export const unixToDateTime = (unixTimestamp: number) => {
  if (unixTimestamp === 0 || unixTimestamp === null || unixTimestamp === undefined) return '';
  // Check if the timestamp is in seconds or milliseconds
  // Assume timestamps longer than 10 digits are in milliseconds
  const timestamp = unixTimestamp > 9999999999 ? unixTimestamp : unixTimestamp * 1000;

  const date = new Date(timestamp);
  const formattedDate =
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '/' +
    date.getDate().toString().padStart(2, '0') +
    '/' +
    date.getFullYear();
  // console.log(formattedDate);
  return formattedDate;
};
